mainApp.component('internetFw', {
	templateUrl: '/public/components/internet-fw.component.html',
	controller: function ($scope, $timeout, $state, $interval, GeneralUtilsService, RulesService) {
		var ctrl = this;

		var origRulesEnabled;
		var INTERNET_FW_ENABLED_FIELD = 'appRulesEnabled';

		ctrl.currentRulesEnabled = false;

		ctrl.fws = [
			{
				type:'outbound_Internet',
				loading: true,
				data: null,
				title: 'Outbound Internet FW',
				field: 'outboundInternetFwRules',
				isChanged: false,
				selectedItems: [],
			},
			{
				type:'WAN',//temp
				loading: true,
				data: null,
				title: 'Inbound Internet FW',
				field: 'wanFwRules',
				isChanged: false,
				selectedItems: [],
			}
		];

		ctrl.toggleFw = function(fwType) {
			var $targetEl = $('#fw-wrapper-' + fwType).find('.fw-header');
			var $expandedEl = $targetEl.siblings('.fw-body');
			$expandedEl.clearQueue();
			if ($targetEl.hasClass('open')) {
				$expandedEl.slideUp(300);
			} else {
				$expandedEl.slideDown(300);
			}
			$targetEl.toggleClass('open');
			$targetEl.find('.toggle-btn').toggleClass('open');
		};

		function getData(fw) {
			var type = fw.type.toUpperCase() + RulesService.FIREWALL_RULE_POSTFIX;
			store.fetch({
				method: 'POST',
				path: 'getRules',
				queryParams: {
					accountId: $state.params.accountId,
					rulesType: type,
				},
				success: function(data) {
					fw.data = data;
					fw.loading = false;
					if (fw.type === 'outbound_Internet') {
						setEnabledValue(fw.data.enabled);
					}

					$scope.$broadcast('updateRules', fw.type);
					$scope.$digest();

				}
			});
		}

		function setEnabledValue(value) {
			origRulesEnabled = value;
			ctrl.currentRulesEnabled = value;
		}

		var windowResize =function () {
			ctrl.setHeaderWidth();
		};

		ctrl.$onInit = function() {
			ctrl.search = '';
		};

		ctrl.$postLink = function() {
			ctrl.fws.forEach(function(fw) {
				getData(fw);
			});

			$(window).resize(windowResize);

			setHeaderStickiness();
		};

		// send save request

		ctrl.getStoreConfiguration = function() {
			var fields = [];
			var dataToSend = {
				newSaveMethod: true,
				id: $state.params.accountId,
			};
			ctrl.fws.forEach(function(fw) {
				fields.push(fw.field);
				dataToSend[fw.field] = fw.data.rules;
			});

			fields.push(INTERNET_FW_ENABLED_FIELD);
			dataToSend[INTERNET_FW_ENABLED_FIELD] = ctrl.currentRulesEnabled;

			return {
				url: '/edit',
				data: dataToSend,
				dataObj: 'json',
				queryParams: {
					accountId: $state.params.accountId,
					save: true,
					fields: '[' + fields.toString() + ']',
				},
			}
		};

		ctrl.postSave = function(newData) {
			ctrl.fws.forEach(function(fw) {
				fw.data.rules = newData.model[fw.field];
				fw.loading = false;
				fw.isChanged = false;
				setEnabledValue(newData[INTERNET_FW_ENABLED_FIELD]);
				$scope.$broadcast('updateRules', fw.type);
			});
			$scope.$root.handleServerResponse(newData, "fwRules", "Firewall rules were saved successfully");
			$scope.$digest();
		};

		ctrl.fwOnChange = function(rulesType, items, isChanged) {
			ctrl.fws.filter(function(fw) { return fw.type === rulesType })[0].isChanged = isChanged;
		};

		ctrl.selectionChange = function (rulesType, newSelectionItems) {
			ctrl.fws.filter(function(fw) { return fw.type === rulesType })[0].selectedItems = newSelectionItems;
		};

		$scope.$root.hasChanges = function() {
			return ctrl.fws.filter(function(fw) { return fw.isChanged }).length > 0 || ctrl.currentRulesEnabled !== origRulesEnabled;
		};


		$scope.tableConfig = {
			fields: RulesService.getFields(),
			titleSearch: 'Search Rules',
		};

		ctrl.openAddRule = function($event) {
			$scope.$root.$emit('$openPopup', 'inner-action-add-fwRule-rule', 'add-rule-btn');
		};

		ctrl.addRule = function (fw, pos) {
			RulesService.addNewCreatedRule(fw.data.rules, fw.type, pos, null, null);
			$scope.$broadcast('updateRules', fw.type);
			$scope.$root.$emit("$closePopup", 'inner-action-add-fwRule-rule');
		};


		ctrl.removeItems = function(){
			var itemsMessage = "";
			var len = 0;
			ctrl.fws.forEach(function(fw) {
				len += fw.selectedItems.length;
				fw.selectedItems.forEach(function(item){
					itemsMessage += item.name;
					i++;
					if(i == fw.selectedItems.length - 1) {
						itemsMessage += " and ";
					}
					else if(i < fw.selectedItems.length - 1) {
						itemsMessage += ", ";
					}
				});
			});

			if(len === 0) {
				$scope.$root.alert("Please select items to delete");
				return;
			}

			itemsMessage = (len === 1?"one rule - ": len + " rules - ") + itemsMessage;
			var i = 0;
			var confirmMessage = "Are you sure you want to remove " +  itemsMessage + "?";
			$scope.$root.confirm(confirmMessage, function(){
				var returnedResponses = 0;
				var error = false;
				ctrl.fws.forEach(function(fw) {
					var itemsToDelete = [];
					fw.selectedItems.forEach(function(item) {
						itemsToDelete.push(item.id);
					});
					//nirtodo: create a server method to take multiple delete collections instead of 2 requests
					store.remove({
						path: 'deleteRules',
						type: fw.type.toUpperCase() + RulesService.FIREWALL_RULE_POSTFIX,
						accountId: $state.params.accountId,
						items: itemsToDelete,
						success: function (data) {
							if (data.status && data.status === 'ERROR') {
								$scope.$root.handleServerResponse(data, "", itemsMessage + " removed successfully");
								error = true;
							} else {
								fw.data.rules = data.data.rules;
								$scope.$broadcast('updateRules', fw.type);
							}

							returnedResponses++;
							if (returnedResponses === ctrl.fws.length) {
								if (!error) {
									$scope.$root.handleServerResponse(data, "", itemsMessage + " removed successfully");
								}

								$scope.$digest();
							}
						}
					});
				});
			});
		};



		$scope.$on('$destroy', function () {
			$(window).off('resize', windowResize);
		});
	}
});